export default __webpack_public_path__ + "static/survey-results-sample-dark-mode-722c8b68af47e64537eedb4e9a5aa9c8.png";